import {isNotNil} from 'ramda-adjunct';

import {Nullish, isNotNilOrZero} from 'shared/web';

export const getRatioFromAmount = (amount: number | Nullish, totalAmount: number | Nullish) =>
  isNotNil(amount) && isNotNilOrZero(totalAmount) ? Math.round((amount / totalAmount) * 100) : null;
